module.exports = __webpack_public_path__ + "static/media/facility-page-banner-1.f7d7b8c0.jpg";